import React, { Component, useState } from 'react';
import * as util from './newUtil.js'; //util.js is old style JS and doesn't declare vars - slowly porting functions into newUtil
import * as properties from './config/properties.js';
import * as THREE from "three";
import { withLocalize, Translate } from "react-localize-redux";
import translations from "./json/translations.json";
import { renderToStaticMarkup } from "react-dom/server";
import { Paper, Button, IconButton, DialogTitle, DialogContent, DialogContentText, Typography, TextField, Popover, MenuItem } from '@material-ui/core';
import HorizontalSplitIcon from '@material-ui/icons/HorizontalSplit';
import CloseIcon from '@material-ui/icons/Close';
import FullscreenIcon from '@material-ui/icons/Fullscreen';
import LinkIcon from '@material-ui/icons/Link';
import Draggable from 'react-draggable';
import PropTypes from 'prop-types';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Rnd } from "react-rnd";
import LoadingOverlay from 'react-loading-overlay';
import ObjectCloudSectionSelector from './ObjectCloudSectionSelector';
import PlacementRenderer from './PlacementRenderer';
import SettingsIcon from '@material-ui/icons/Settings';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import Slider from 'rc-slider';
import SpriteText from 'three-spritetext';
import YuchsinTree from './YuchsinTree';
import HierarchicalSelect from 'react-hierarchical-select';
import NameDropdown from './NameDropdown';
import YuchsinSectionSelector from './YuchsinSectionSelector';
import './css/YuchsinTree.css';
import { MenuProvider } from 'react-contexify';
import 'react-contexify/dist/ReactContexify.min.css';
import ContextMenu from './ContextMenu';
import { contextMenu } from 'react-contexify';
import SearchIcon from '@material-ui/icons/Search';
import nodeConnect from './images/nodeConnectOrange.jpg';
import ToggleIconButton from './ToggleIconButton';
import ancestorsOn from './images/ancestorsOn.jpg';
import ancestorsOff from './images/ancestorsOff.jpg';
import descendantsOn from './images/descendantsOn.jpg';
import descendantsOff from './images/descendantsOff.jpg';
import play from './images/play.jpg';
import pause from './images/pause.jpg';
import repeatFromStartOn from './images/repeatFromStartOn.jpg';
import repeatFromStartOff from './images/repeatFromStartOff.jpg';
import repeatFromEndOn from './images/repeatFromEndOn.jpg';
import repeatFromEndOff from './images/repeatFromEndOff.jpg';
import oneGenerationOn from './images/oneGenerationOn.jpg';
import oneGenerationOff from './images/oneGenerationOff.jpg';
import allGenerationsOn from './images/allGenerationsOn.jpg';
import allGenerationsOff from './images/allGenerationsOff.jpg';


const createSliderWithTooltip = Slider.createSliderWithTooltip;

const styles = theme => ({
  toggleContainer: {
    backgroundColor: 'transparent',
    //padding: `${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    alignItems: 'center',
    margin: `auto`,
    background: theme.palette.background.default,
  },
});

function BaseParameters() {
  this.source = null;
  this.clientIP = null;
  this.morphInflections = null;
  this.filterIds = null;
  this.limit = 2100;
  this.minimumFrequency = 1;
  this.skipTerms = [];
  this.nGrams = null;
  this.sortResultsBy = null;
  this.resultsToDisplay = null;
  this.namedLocations = []; //NamedLocation()
  this.namedLocations2 = []; //NamedLocation()
  this.pasukRangeLocations = []; //PerekPasukRange()
  this.pasukRangeLocations2 = []; //PerekPasukRange()
}

function TimelineParameters() {
    this.searchLevel =  null; //int
    this.isInSequence = null; //bool
    this.morphInflections = null; //str
    this.scope = null; //str
    this.filterIds = null; //str
    this.includeExcludeLNTs = []; //IncludeExcludeLNT()
    this.namedLocations =  []; //NamedLocation()
    this.pasukRangeLocations = []; //PerekPasukRange()
    this.bituiParameters = []; //TermParameters()
    this.termDistances = [];
    this.pasukIds = [];
    this.searchWithinResults = false;
    this.yearStartRange = 0;
    this.yearEndRange = 2000;
    this.objectId = 0;
    this.action = null;
}

function TermParameters(){
  this.term = "";
}

function NamedLocation(kriaId, aliyaId) {
  this.kriaId =  kriaId; //int
  this.aliyaId = aliyaId; //int
}

function PerekPasukRange(seferId1, perekNum1, pasukNum1, seferId2, perekNum2, pasukNum2) {
  this.seferId1 =  seferId1; //int
  this.perekNum1 = perekNum1;  //int
  this.pasukNum1 =  pasukNum1; //int
  this.seferId2 = seferId2;  //int
  this.perekNum2 =  perekNum2; //int
  this.pasukNum2 = pasukNum2;  //int
}

function ObjectRelationshipParameters() {
    this.objectIds = []
}
function encodeFilterIds(nodes, nodeString) {
    var nodeStr = (nodeString != undefined) ? nodeString : "0".repeat(44);
    nodes.forEach((node)=>{
        if (node.tableName == "Sefer" && node.isChecked)
            nodeStr = util.stuff(nodeStr, "1", node.id-1, 1);
        if(node.children){
            nodeStr = encodeFilterIds(node.children, nodeStr);
        }
    })
    return nodeStr;
}

function getEquallySpacedPointOnCircle(point, totalPoints, radius, centerXY) {
    var center = (centerXY == null) ? {x: 0, y: 0} : centerXY;
    var slice = 2 * Math.PI / totalPoints;
    var angle, newX, newY;

    angle = slice * point;
    newX = Math.round(center.x + radius * Math.cos(angle), 0);
    newY = Math.round(center.y + radius * Math.sin(angle), 0);
    return {x: newX, y: newY};
}

function YichusItem(props) {
    const parents = props.translate("parents");
    const father = props.translate("father");
    const mother = props.translate("mother");
    const husband = props.translate("husband");
    const wife = props.translate("wife");
    const son = props.translate("son");
    const daughter = props.translate("daughter");
    const of = props.translate("of");
    const noRelation = props.translate("noRelation");

    const pathItem = props.item;
    var itemContent, relationship;

    if (pathItem.name == "")
        itemContent = <></>;
    else if (pathItem.name == noRelation)
        itemContent = <i>{noRelation}</i>;
    else {
        relationship = "";
        if (pathItem.relationshipType == "Parent" && pathItem.categoryType == "FAMILY")
            relationship = parents;
        else if (pathItem.relationshipType == "Parent" && pathItem.categoryType == "MAN")
            relationship = father;
        else if (pathItem.relationshipType == "Parent" && pathItem.categoryType == "WOMAN")
            relationship = mother;
        else if (pathItem.relationshipType == "Spouse" && pathItem.categoryType == "MAN")
            relationship = husband;
        else if (pathItem.relationshipType == "Spouse" && pathItem.categoryType == "WOMAN")
            relationship = wife;
        else if (pathItem.relationshipType == "Child" && pathItem.categoryType == "MAN")
            relationship = son;
        else if (pathItem.relationshipType == "Child" && pathItem.categoryType == "WOMAN")
            relationship = daughter;

        itemContent = <><b>{pathItem.name}</b>{(pathItem.relationshipType != "") ? ", " + relationship + " " + of + "\n" : ""}</>;
    }

    return <>{itemContent}</>;
}

function YichusPath(props) {
  if (props.path.length == 0)
      return <span></span>;

  const listItems = props.path.map((yichusItem) =>
      <YichusItem item={yichusItem} translate={props.translate}/>
  );


//        descriptionPathText += "======\n";
//        for (i=0; path && i < path.length; i++) {
//            descriptionPathText += path[i].name + ":" + path[i].relationshipType + "\n";
//        }
  return <>{listItems}</>;
}

class YuchsinTreeViewer extends Component {

 constructor(props) {
    super(props);

    //var graphData = {"nodes": [{"name": "LOADING...", "displayCaption": "LOADING..."}], "links": []};

//    var i, label = "0", oldLabel;
//    for (i=0; i <= 4000; i+=200) {
//       oldLabel = label;
//       label = i.toString();
//       graphData.nodes.push({"fx": 0, "fy": -i*1.5, "fz": 0, "id": "year" + label, "name": label, "displayCaption": label, "gender": "", "tanachYear": i, "type": ("timeline" + ((i%1000 == 0) ? "-lg" : "-sm")) });
//       if (label != oldLabel)
//           graphData.links.push({"source": "year" + oldLabel, "target": "year" + label, "type": "timeline", "linkYears": "true"});
//    }

    this.state = {
      isLoading: false,
      isGraphMounted: false,
      zIndex: 801,
      yuchsinData: null,
      focusedNode: null,
      comparisonNode: null,
      pathText: "",
      rightClickedNode: null,
      textSelectorData: [{ type: true, val1: 0, val2: 0, val3: 0, val4: 0, val5: 0, val6: 0, valList1: [], valList2: [], valList3: [], valList4: [], valList5: [], valList6: [] }],
      peopleData: [],
      yichusPath: [],
      highlightNodeIds: [],
      pathNodeIds: [],
      ancestorNodeIds: [],
      descendantNodeIds: [],
      ancestorNodeDepths: [],
      descendantNodeDepths: [],
      showAncestors: false,
      showDescendants: false,
      settingsIsOpen: false,
      settingsAnchorEl: null,
      maxGenerations: 60,
      maxGenerationsDisplay: '∞',
      findRelationIsOpen: false,
      findRelationDraggable: true,
      findRelationAnchorEl: null,
      findRelationPosition: { //relative to this.props.x,y
        x: 360,
        y: 50,
      },
      isGenerationsPlaying: false,
      isGenerationsAll: true,
      isGenerationsOne: false,
      isRepeatGenerationsFromStart: false,
      isRepeatGenerationsFromEnd: false,
      isPathPlaying: false,
      isRepeatPathFromStart: false,
      isRepeatPathFromEnd: false,
      isViewerOpenedYet: false,
      colorTheme: null
    };

/*
        this.setState({
            yuchsinTreeViewerPosition: {
                widthNum: widthNum,
                heightNum: window.innerHeight > 800 ? 800 : window.innerHeight - 200,
                x: ((window.innerWidth - widthNum) / 2) + homeScrollContainer.scrollLeft,
                y: (window.innerHeight - heightNum) / 2,
*/
    this.props.initialize({
      languages: [
        { name: "עברית", code: "he" },
        { name: "English", code: "en" }
      ],
      translation: translations,
      options:  { renderToStaticMarkup, renderInnerHtml: true, defaultLanguage: this.props.activeLanguage ? this.props.activeLanguage.code : 'en' }
    });

    this.props.addTranslation(translations);
    this.setLanguage = (code) => {props.setActiveLanguage(code)}
    // Kalman Claudsky: ref targets the pathText container div (not the MUI Paper) because
    // MUI v3 Paper is a class component and returns its instance rather than the DOM node,
    // so el.contains() would silently fail if the ref were attached to the Paper itself.
    this.pathTextRef = React.createRef();
    this.handlePathTextKeyDown = this.handlePathTextKeyDown.bind(this);
    this.handleGlobalKeyDown = this.handleGlobalKeyDown.bind(this);
    this.getYuchsinData = this.getYuchsinData.bind(this);
    this.setFocusedNode = this.setFocusedNode.bind(this);
    this.findNodeByName = this.findNodeByName.bind(this);
    this.setComparisonNode = this.setComparisonNode.bind(this);
    this.setRightClickedNode = this.setRightClickedNode.bind(this);
    //    this.onInputChange = this.onInputChange.bind(this);
    //    this.onChange = this.onChange.bind(this);
    //    this.selectPerson = this.selectPerson.bind(this);
    this.handlePeople = this.handlePeople.bind(this);
    this.textSelectorGridReady = this.textSelectorGridReady.bind(this);
    this.modifyTextSelectorRow = this.modifyTextSelectorRow.bind(this);
    this.addTextSelectorRow = this.addTextSelectorRow.bind(this);
    this.deleteTextSelectorRow = this.deleteTextSelectorRow.bind(this);
    this.searchPersonInTanach = this.searchPersonInTanach.bind(this);
    this.findYichus = this.findYichus.bind(this);
    this.handleOpenFindRelation = this.handleOpenFindRelation.bind(this);
    this.handleCloseFindRelation = this.handleCloseFindRelation.bind(this);
    this.setFindRelationDraggable = this.setFindRelationDraggable.bind(this);
    this.toggleAncestors = this.toggleAncestors.bind(this);
    this.toggleDescendants = this.toggleDescendants.bind(this);
    this.fetchLineage = this.fetchLineage.bind(this);
    this.handleOpenSettings = this.handleOpenSettings.bind(this);
    this.handleCloseSettings = this.handleCloseSettings.bind(this);
    this.setMaxGenerations = this.setMaxGenerations.bind(this);
    this.toggleGenerationsPlayPause = this.toggleGenerationsPlayPause.bind(this);
    this.toggleGenerationsAll = this.toggleGenerationsAll.bind(this);
    this.toggleGenerationsOne = this.toggleGenerationsOne.bind(this);
    this.toggleRepeatGenerationsFromStart = this.toggleRepeatGenerationsFromStart.bind(this);
    this.toggleRepeatGenerationsFromEnd = this.toggleRepeatGenerationsFromEnd.bind(this);
    this.togglePathPlayPause = this.togglePathPlayPause.bind(this);
    this.toggleRepeatPathFromStart = this.toggleRepeatPathFromStart.bind(this);
    this.toggleRepeatPathFromEnd = this.toggleRepeatPathFromEnd.bind(this);
    this.playRepeatFromEnd = this.playRepeatFromEnd.bind(this);
    this.setColorTheme = this.setColorTheme.bind(this);
  }

    setColorTheme(theme) {
        this.setState({colorTheme: theme});
    }

    handleOpenSettings(e){
      this.setState({
        settingsIsOpen: true,
        settingsAnchorEl: e.currentTarget
      })
    }

    handleCloseSettings(){
      this.setState({
        settingsIsOpen: false,
        settingsAnchorEl: null
      })
    }

  getDisplayValue(value){
    if(value === 60){
      value = '∞'
    }
    return `${value}`;
  }

  setMaxGenerations(val){
      var dispVal = this.getDisplayValue(val);
      this.setState({maxGenerations: val, maxGenerationsDisplay: dispVal});
  }

 getNewtimelineParameters(yearStartRange, yearEndRange) {
    var timelineParams = new TimelineParameters();
    timelineParams.yearStartRange = yearStartRange
    timelineParams.yearEndRange = yearEndRange
    return timelineParams
 }
 getNewObjectRelationshipParameters(objectIds) {
    var ObjParams = new ObjectRelationshipParameters();
    ObjParams.objectIds = objectIds
    return ObjParams
 }

  getTextSelectorRenderVals(textDataRow) {
    var renderVal1, renderVal2, renderVal3, renderVal4, renderVal5, renderVal6
    var renderVals
    if (textDataRow.type) { //is named section
      var selectedVal1 = textDataRow.valList1.filter(obj => { return obj.id === textDataRow.val1 });
      var selectedVal2 = textDataRow.valList2.filter(obj => { return obj.id === textDataRow.val2 });
      var selectedVal3 = textDataRow.valList3.filter(obj => { return obj.id === textDataRow.val3 });
      var selectedVal4 = textDataRow.valList4.filter(obj => { return obj.id === textDataRow.val4 });
      var selectedVal5 = textDataRow.valList5.filter(obj => { return obj.id === textDataRow.val5 });

      if (selectedVal1[0]) { renderVal1 = selectedVal1[0].value + ' > ' }
      if (selectedVal2[0]) { renderVal2 = selectedVal2[0].value + ' > ' }
      if (selectedVal3[0]) { renderVal3 = selectedVal3[0].value + ' > ' }
      if (selectedVal4[0]) { renderVal4 = selectedVal4[0].value + ' > ' }
      if (selectedVal5[0]) { renderVal5 = selectedVal5[0].value + ' > ' }

      var renderVals = [renderVal1, renderVal2, renderVal3, renderVal4, renderVal5]

      for (let i = 4; i >= 0; i--) {
        if (renderVals[i]) {
          renderVals[i] = renderVals[i].substring(0, renderVals[i].length - 3)
          break
        }
        //if it is defined, set the one after it as the last value
      }

    } else { //is pasuk range
      var selectedVal1 = textDataRow.valList1.filter(obj => { return obj.seferId === textDataRow.val1 });
      var selectedVal2 = textDataRow.valList2.filter(obj => { return obj.perekNum === textDataRow.val2 });
      var selectedVal3 = textDataRow.valList3.filter(obj => { return obj.pasukNum === textDataRow.val3 });
      var selectedVal4 = textDataRow.valList4.filter(obj => { return obj.seferId === textDataRow.val4 });
      var selectedVal5 = textDataRow.valList5.filter(obj => { return obj.perekNum === textDataRow.val5 });
      var selectedVal6 = textDataRow.valList6.filter(obj => { return obj.pasukNum === textDataRow.val6 });

      if (selectedVal1[0]) { renderVal1 = selectedVal1[0].seferName }
      if (selectedVal2[0]) { renderVal2 = selectedVal2[0].perekValue }
      if (selectedVal3[0]) { renderVal3 = selectedVal3[0].pasukValue }
      if (selectedVal4[0]) { renderVal4 = selectedVal4[0].seferName }
      if (selectedVal5[0]) { renderVal5 = selectedVal5[0].perekValue }
      if (selectedVal6[0]) { renderVal6 = selectedVal6[0].pasukValue }

      renderVals = [renderVal1, renderVal2, renderVal3, renderVal4, renderVal5, renderVal6]
    }

    return renderVals
  }

  textSelectorGridReady = params => {
    this.setState({
      textSelectorApi: params.api,
      textSelectorColumnApi: params.columnApi
    }, () => {
      this.state.textSelectorApi.setRowData(this.state.textSelectorData);

      //following CSS classes seem to get overridden below in PlacementRenderer by placementGridLine and rangeGridLine
      this.state.textSelectorApi.setColumnDefs(
        [{
          headerName: this.props.translate("addLines"), headerClass: 'row-thin-center', field: "namedSection", width: 1168, cellClass: "row-thin-small", cellRendererFramework: PlacementRenderer, cellRendererParams:
          {
            placementRowData:this.props.placementRowData,
            extModifyPlacementRow: this.modifyTextSelectorRow,
            extAddPlacementRow: this.addTextSelectorRow,
            extDeletePlacementRow: this.deleteTextSelectorRow,
            translate: this.props.translate, //do I need to pass this here?
          },
          //cellClass: function(params) {return params.data.type ? 'placementGridLine' : 'rangeGridLine';},
        }]
      );
      if (this.state.textSelectorData.length > 0)
        this.state.textSelectorApi.setFocusedCell(0, "namedSection", null);
      //   var instances = this.refs.agGrid.gridOptions.api.getCellRendererInstances(params);
    })
  };

  modifyTextSelectorRow(extState) {
    var isAddRow = (extState.type && extState.val4 != this.state.textSelectorData.val4 && extState.val4 != 0) || (!extState.type && extState.val3 != this.state.textSelectorData.val3 && extState.val3 != 0 && extState.val6 != this.state.textSelectorData.val6 && extState.val6 != 0);
    var selected = this.state.textSelectorApi.getFocusedCell();

    var i = selected.rowIndex;
    var rowValues = {
      type: extState.type, val1: extState.val1, val2: extState.val2, val3: extState.val3, val4: extState.val4, val5: extState.val5, val6: extState.val6,
      valList1: extState.valList1, valList2: extState.valList2, valList3: extState.valList3, valList4: extState.valList4, valList5: extState.valList5, valList6: extState.valList6
    };
    var newData = this.state.textSelectorData;
    newData[i] = rowValues;

    this.setState({ textSelectorData: newData }, () => {
      if (i == this.state.textSelectorApi.getLastDisplayedRow() && isAddRow) {
        this.addTextSelectorRow();
      }else{
        this.setState({textSelectorData:[]},()=>{
          this.state.textSelectorApi.updateRowData({ update: [rowValues] });
          this.setState({ textSelectorData: newData })
        })
      }
    });
  }

  addTextSelectorRow() {
    var newRow = { type: true, val1: 0, val2: 0, val3: 0, val4: 0, val5: 0, val6: 0, valList1: [], valList2: [], valList3: [], valList4: [], valList5: [], valList6: [] };
    var newData = this.state.textSelectorData;
    newData.push(newRow);
    this.setState({textSelectorData:[]},()=>{
      this.state.textSelectorApi.updateRowData({ add: [newRow] });
      this.setState({ textSelectorData: newData, rowDataLength:newData.length-1 })
    })
  }

  deleteTextSelectorRow(extState) {
    var selected = this.state.textSelectorApi.getFocusedCell();
    var i = selected.rowIndex;
    if (i == this.state.textSelectorApi.getLastDisplayedRow()) { //then just clear
      this.modifyTextSelectorRow(extState);
      //selected.setSelected(false);
    }
    else {
      var selectedData = this.state.textSelectorApi.getSelectedRows();
      var newData = this.state.textSelectorData;
      newData.splice(i, 1);
      this.setState({ textSelectorData: newData, rowDataLength:i }, () => { this.state.textSelectorApi.updateRowData({ remove: selectedData }) });
    }
  }

  // Kalman Claudsky: register a document-level keydown listener rather than relying on
  // React's onKeyDown prop. When a user clicks plain text in a div, the browser does not
  // move DOM focus to that element even if it has tabIndex, so a React synthetic onKeyDown
  // on the Paper/container never fires for Ctrl+A. The document listener fires regardless
  // of focus and lets us check whether the selection anchor is inside our target element.
  componentDidMount() {
      document.addEventListener('keydown', this.handleGlobalKeyDown);
  }

  componentWillUnmount() {
      document.removeEventListener('keydown', this.handleGlobalKeyDown);
  }


  async getYuchsinData(callingSource) { //allowable sources are opener, graph and refresh
    var isIncludeFilters = false;
    var isGraphMounted = this.state.isGraphMounted;
    if (callingSource == "refresh")
       isIncludeFilters = true;
    else if (callingSource == "graph") {
       this.setState({ isGraphMounted: true });
       isGraphMounted = true;
    }

    if (callingSource != "refresh" && (this.state.yuchsinData !=null || !isGraphMounted || !this.props.isOpen) )
        return; //only fetch data if forced to by a refresh or else of it's first time page was loaded to get general data AND the yuchsin window is open

    document.getElementById("yuchsinTreeLoading").style.display = "block";
    var timelineParams = new TimelineParameters();
    timelineParams.filterIds = "FFFFFFFFFFF";

    if (isIncludeFilters) {
        var filterIds = encodeFilterIds(this.props.extFilterData);

        filterIds = parseInt(filterIds, 2).toString(16).toUpperCase();
        filterIds = util.right("00000000000"+filterIds,11);

        timelineParams.filterIds = filterIds;

        var e, i, j, k;
        for (i = 0; i < this.state.textSelectorData.length-1; i++) { //last position in textSelectorData is never populated
            e = this.state.textSelectorData[i];
            if (e.type)
                timelineParams.namedLocations.push(new NamedLocation(e.val4, e.val5)); //kriaId, aliyaId
            else
                timelineParams.pasukRangeLocations.push(new PerekPasukRange(e.val1, e.val2, e.val3, e.val4, e.val5, e.val6)); //int
        }
    }

    var graphData = {"nodes": [], "links": []};
    //console.log("graphData = " + graphData)
    var time1 = (new Date()).getTime();

    timelineParams.action = "getYuchsinData" + (this.props.initializedToFullScreen != null && this.props.initializedToFullScreen ? ":fullScreen" : "");

    var response = await fetch(properties.env.webServiceURL + '/BaseHaSefer/getYuchsinData', {method: 'post', body: JSON.stringify(timelineParams)});
    const nodesLinksData = await response.json();
//    sending nodesData as props to parent:
    //@@@@@@2todo - reinstate this???? this.props.peopleData(nodesData);
    const nodesData = nodesLinksData[0];
    const linksData = nodesLinksData[1];

      var nameDropdownData = [];
      var newNode;
      var isPersonNode;

//considered adding properties for inPath, inAncestors, inDescendants - in future if this gets more complex w/more highlighting properties then might want to create a
//single highlighting property for the node object and use something like Lodash or CollectionsJS to add set-like or hashmap-like indicators where can check node.highlighting.isProp("ancestor"), etc.
//but..... in YuchsinTree.js, componentDidUpdate() checks for every change in this.props.data !== prevProps.data so when adding highlightin stats, don't want to overburden componentDidUpdate()
/*
each button click whether:
   focus on new person via dropdown or node-click
   toggle ancestors
   toggle descendants
   adjust max generations
   findpath: select target person
   findpath: close popup
   toggle "directional arrows"
   toggle "directional particles"

affects highlighting for nodes, connectors
        size & color of particles

should 1st alter relevant state and then fire rerender that takes all state into account and sets appropriate highlighting

driven by componentDidUpdate() of yuchsintree
   which checks for change in props.highlightNodeIds array
   calls this.highlightNodes(true/false) - now needs to be more fine-grained

render = f()
   node1 selected
   node2 selected if any
   findPath:isOpen
   ancestors:isOn
   descendants:isOn
   maxGenerations
   arrows: isOn
   particles: isOn

highlightNodes - need to store array of whether node highlighted by path, anc, desc - any Collection object in JS instead of array?


to not to do new yichus lookup if recently did looku for same info - where to store this??
*/

if (false) {
var fx, fz, loc, kayin;

graphData.nodes.push({"fx": 10, "fy": 2500, "fz": 0, "id": 1, "name": "אדם", "fullName": "אדם", "displayCaption": "אדם", "gender": "MAN", "tanachYear": 0, "type": "person", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});
graphData.nodes.push({"fx": 110, "fy": 2500, "fz": 0, "id": 2, "name": "חוה", "fullName": "חוה", "displayCaption": "חוה", "gender": "WOMAN", "tanachYear": 0, "type": "person", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});
graphData.nodes.push({"fx": 60, "fy": 2500, "fz": 0, "id": 3, "name": "אדם:חוה", "fullName": "אדם:חוה", "displayCaption": "", "gender": "FAMILY", "tanachYear": 0, "type": "family", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});

kayin = loc = getEquallySpacedPointOnCircle(0, 3, 100, {x:60, y:0});
graphData.nodes.push({"fx": loc.x, "fy": 2350, "fz": loc.y, "id": 4, "name": "קין", "fullName": "קין בן אדם", "displayCaption": "קין", "gender": "MAN", "tanachYear": 0, "type": "person", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});
loc = getEquallySpacedPointOnCircle(1, 3, 100, {x:60, y:0});
graphData.nodes.push({"fx": loc.x, "fy": 2350, "fz": loc.y, "id": 5, "name": "הבל", "fullName": "הבל בן אדם", "displayCaption": "הבל", "gender": "MAN", "tanachYear": 0, "type": "person", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});
loc = getEquallySpacedPointOnCircle(2, 3, 100, {x:60, y:0});
graphData.nodes.push({"fx": loc.x, "fy": 2350, "fz": loc.y, "id": 6, "name": "שת", "fullName": "שת בן אדם", "displayCaption": "שת", "gender": "MAN", "tanachYear": 0, "type": "person", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});

graphData.nodes.push({"fx": loc.x, "fy": 2200, "fz": loc.y, "id": 7, "name": "אנוש", "fullName": "אנוש בן שת", "displayCaption": "אנוש", "gender": "MAN", "tanachYear": 0, "type": "person", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});
graphData.nodes.push({"fx": loc.x, "fy": 2050, "fz": loc.y, "id": 8, "name": "קינן", "fullName": "קינן בן אנוש", "displayCaption": "קינן", "gender": "MAN", "tanachYear": 0, "type": "person", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});
graphData.nodes.push({"fx": kayin.x, "fy": 2200, "fz": kayin.y, "id": 9, "name": "חנוך", "fullName": "חנוך בן קין", "displayCaption": "חנוך", "gender": "MAN", "tanachYear": 0, "type": "person", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});
graphData.nodes.push({"fx": kayin.x, "fy": 2050, "fz": kayin.y, "id": 10, "name": "עירד", "fullName": "עירד בן חנוך", "displayCaption": "עירד", "gender": "MAN", "tanachYear": 0, "type": "person", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});
graphData.nodes.push({"fx": kayin.x, "fy": 1900, "fz": kayin.y, "id": 11, "name": "מחויאל", "fullName": "מחויאל בן עירד", "displayCaption": "מחויאל", "gender": "MAN", "tanachYear": 0, "type": "person", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});
graphData.nodes.push({"fx": kayin.x, "fy": 1750, "fz": kayin.y, "id": 12, "name": "מתושאל", "fullName": "מתושאל בן מחויאל", "displayCaption": "מתושאל", "gender": "MAN", "tanachYear": 0, "type": "person", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});
graphData.nodes.push({"fx": kayin.x, "fy": 1600, "fz": kayin.y, "id": 13, "name": "למך", "fullName": "למך בן מתושאל", "displayCaption": "למך", "gender": "MAN", "tanachYear": 0, "type": "person", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});
graphData.nodes.push({"fx": kayin.x-100, "fy": 1600, "fz": kayin.y, "id": 14, "name": "עדה", "fullName": "עדה", "displayCaption": "עדה", "gender": "WOMAN", "tanachYear": 0, "type": "person", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});
graphData.nodes.push({"fx": kayin.x+100, "fy": 1600, "fz": kayin.y, "id": 15, "name": "צלה", "fullName": "צלה", "displayCaption": "צלה", "gender": "WOMAN", "tanachYear": 0, "type": "person", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});
graphData.nodes.push({"fx": kayin.x-50, "fy": 1600, "fz": kayin.y, "id": 16, "name": "למך בן מתושאל:עדה", "fullName": "למך בן מתושאל:עדה", "displayCaption": "", "gender": "FAMILY", "tanachYear": 0, "type": "family", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});
graphData.nodes.push({"fx": kayin.x+50, "fy": 1600, "fz": kayin.y, "id": 17, "name": "למך בן מתושאל:צלה", "fullName": "למך בן מתושאל:צלה", "displayCaption": "", "gender": "FAMILY", "tanachYear": 0, "type": "family", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});
graphData.nodes.push({"fx": kayin.x-50, "fy": 1450, "fz": kayin.y, "id": 18, "name": "יבל", "fullName": "יבל בן למך", "displayCaption": "יבל", "gender": "MAN", "tanachYear": 0, "type": "person", "aliases": "", "firstPasukLocation": "", "firstPasukText": "", collapsed: false, childLinks: []});

graphData.links.push({"source": 1, "target": 3, "type": "spouse"})
graphData.links.push({"source": 2, "target": 3, "type": "spouse"})
graphData.links.push({"source": 3, "target": 4, "type": "child"})
graphData.links.push({"source": 3, "target": 5, "type": "child"})
graphData.links.push({"source": 3, "target": 6, "type": "child"})
graphData.links.push({"source": 6, "target": 7, "type": "child"})
graphData.links.push({"source": 7, "target": 8, "type": "child"})
graphData.links.push({"source": 4, "target": 9, "type": "child"})
graphData.links.push({"source": 9, "target": 10, "type": "child"})
graphData.links.push({"source": 10, "target": 11, "type": "child"})
graphData.links.push({"source": 11, "target": 12, "type": "child"})
graphData.links.push({"source": 12, "target": 13, "type": "child"})
graphData.links.push({"source": 13, "target": 16, "type": "spouse"})
graphData.links.push({"source": 14, "target": 16, "type": "spouse"})
graphData.links.push({"source": 13, "target": 17, "type": "spouse"})
graphData.links.push({"source": 15, "target": 17, "type": "spouse"})
graphData.links.push({"source": 16, "target": 18, "type": "child"})
//source is id2?????
//how get null for 1st pasuk id????? 237 vs 1107
//why is Noach, Mesushelach, Mehalalel ben Keinan,Chava not detected here??
}

    //var arr = []
    var connectedNodes = [];

    //if (false) {
    for(var i = 0; i < linksData.length; i++) {
//       if (!connectedNodes.includes(linksData[i].id1))
//           connectedNodes.push(linksData[i].id1);
//       if (!connectedNodes.includes(linksData[i].id2))
//           connectedNodes.push(linksData[i].id2);
       graphData.links.push({"source": linksData[i].id1, "target": linksData[i].id2, "type": (nodesData[i].objectRelationTypeId === "3" ? "child" : "spouse")})
    }//nodeAutoColorBy
    //}

    //if (false) {
    for(var i = 0; i < nodesData.length; i++) {
       //arr.push(nodesData[i].objectId)
       if (nodesData[i].objectId == 18 || nodesData[i].objectId == 42 || nodesData[i].objectId == 937 || nodesData[i].objectId == 2085) //temporariliy handle 18eden,42tuval,937dishon 2085rodanim that were appearing at year 0
           nodesData[i].fy = -11000;
       isPersonNode = nodesData[i].objectTypeId == 7;
       if (nodesData[i].fx != null && nodesData[i].fz != null) //such as Adam, Chava where want to set fully fixed root node position
           newNode = {"fx": nodesData[i].fx, "fy": nodesData[i].fy+6300, "fz": nodesData[i].fz, "id": nodesData[i].objectId,
                      "name": nodesData[i].name, "fullName": nodesData[i].dropdownName, "displayCaption": nodesData[i].displayCaption,
                      "gender": nodesData[i].category_en, "tanachYear": nodesData[i].tanachYear, "type": (isPersonNode ? "person" : "family"),
                      "aliases": nodesData[i].alias, "firstPasukLocation": nodesData[i].firstPasukLocation, "firstPasukText": nodesData[i].firstPasukText,
//                      "isConnected": connectedNodes.includes(nodesData[i].objectId),
                      collapsed: false, childLinks: []};
       else
           newNode = {"fy": nodesData[i].fy+6300, "id": nodesData[i].objectId,
                      "name": nodesData[i].name, "fullName": nodesData[i].dropdownName, "displayCaption": nodesData[i].displayCaption,
                      "gender": nodesData[i].category_en, "tanachYear": nodesData[i].tanachYear, "type": (isPersonNode ? "person" : "family"),
                      "aliases": nodesData[i].alias, "firstPasukLocation": nodesData[i].firstPasukLocation, "firstPasukText": nodesData[i].firstPasukText,
//                      "isConnected": connectedNodes.includes(nodesData[i].objectId),
                      collapsed: false, childLinks: []};
       graphData.nodes.push(newNode);
       if (isPersonNode) {
           if (nodesData[i].dropdownName != null && nodesData[i].dropdownName != "")
               nameDropdownData.push({"index": i, "name": nodesData[i].dropdownName});
       }
    }
    //}

      nameDropdownData = nameDropdownData.sort((a,b) => {
      //alphabetize nodes by name (without nekudot)
      if (util.removeNikud(a.name) > util.removeNikud(b.name)) {
          return 1;
      }
      if (util.removeNikud(b.name) > util.removeNikud(a.name)) {
          return -1;
      }
      return 0;
      })

    //var ObjParams = this.getNewObjectRelationshipParameters(arr);
    //response = await fetch(properties.env.webServiceURL + '/BaseHaSefer/getObjectRelationships', {method: 'post', body: JSON.stringify(ObjParams)});
    //const linksData = await response.json();

    var time2 = (new Date()).getTime();
    console.log("Total duration (ms) of 3D data load = " + (time2-time1));
//    response = await fetch(properties.env.webServiceURL + '/BaseHaSefer/getTimelineYears', {method: 'post', body: JSON.stringify(timelineParams)});
//    const timelineYears = await response.json();
//      var topLevelNodes = [];
// for collapsing nodes functionality
//    // link parent/children
//    const nodesById = Object.fromEntries(graphData.nodes.map(node => [node.id, node]));
//    graphData.links.forEach(link => {
//      nodesById[link.source].childLinks.push(link);
//    });
//
/*
    for(var i = 0; i < graphData.nodes.length; i++) {
        var topLevelNode = true
        for(var j = 0; j < graphData.links.length; j++) {
             if(graphData.links[j].target == graphData.nodes[i].id) {
                topLevelNode = false
                break;
             }
        }
        if(topLevelNode) {
            //topLevelNodes.push(graphData.nodes[i].id)
            graphData.links.push({"source": "year" + graphData.nodes[i].tanachYear, "target": graphData.nodes[i].id, "type": "timeline"})
        }
    }
*/
// for collapsing nodes functionality
//    const getPrunedTree = () => {
//      const visibleNodes = [];
//      const visibleLinks = [];
//
//      topLevelNodes.forEach(id => {
//          (function traverseTree(node = nodesById[id]) {
//            visibleNodes.push(node);
//            if (node.collapsed) return;
//            visibleLinks.push(...node.childLinks);
//            node.childLinks
//              .map(link => ((typeof link.target) === 'object') ? link.target : nodesById[link.target]) // get child node
//              .forEach(traverseTree);
//          })(); // IIFE
//
//          return { nodes: visibleNodes, links: visibleLinks };
//      });
//    };
//
    //var timelineYears = new Set()
    //for(var i = 0; i < graphData.nodes.length; i++)
    //    timelineYears.add(graphData.nodes[i].tanachYear)
    //graphData.nodes.push({"fx": 0, "fy": 150, "fz": 0, "id": 0, "name": "title", "displayCaption": "וְאֵלֶּה רָאשֵׁי אֲבֹתֵיהֶם וְהִתְיַחְשָׂם" + "\n" + "(עזרא ח:א)", "gender": "", "tanachYear": null, "type": "timeline-lg"});
    var i, label = "0", oldLabel;
    for (i=0; i <= 4000; i+=200) {
       oldLabel = label;
       label = i.toString();
       graphData.nodes.push({"fx": 0, "fy": -i*3+6300, "fz": 0, "id": "year" + label, "name": null, "displayCaption": label, "gender": "", "tanachYear": i, "type": ("timeline" + ((i%1000 == 0) ? "-lg" : "-sm")) });
       if (label != oldLabel) {
           graphData.links.push({
               "source": "year" + oldLabel,
               "target": "year" + label,
               "type": "timeline",
               "linkYears": "true"
           });
       }
    }
    //return graphData;
    //var nameDropdownData = []; //this.getNameDropdownData(graphData);

    var initialNode = this.findNodeByName(graphData, this.props.personFullName);
    var initialNode2 = this.findNodeByName(graphData, this.props.personFullName2);
    var findRelationIsOpen = initialNode != null && initialNode2 != null ? true : this.state.findRelationIsOpen;
    var findRelationPosition = this.state.findRelationPosition;
    var isPathPlaying = false;
    var isAnimate = this.props.animate && "YT".indexOf(this.props.animate.toUpperCase()) >= 0;
    var callback = null;
    if (findRelationIsOpen && initialNode2 != null && isAnimate) {
        findRelationPosition = {x: 0, y: this.props.heightNum - 400, widthNum: 360, heightNum: 360};
        isPathPlaying = true;
        callback = this.playRepeatFromEnd;
    }

    this.setState({ yuchsinData: graphData, nameDropdownData, focusedNode: initialNode, comparisonNode: initialNode2,
                    findRelationIsOpen: findRelationIsOpen, findRelationPosition: findRelationPosition}, () => {
        if (findRelationIsOpen && initialNode2 != null) {
            this.findYichus(callback);
        }
        this.setState({isViewerOpenedYet: true});
    });
  }

  //gender, aliases, f(levenshtein)
  findNodeByName(graphData, personFullName) {
    if (personFullName == null || personFullName.trim().length == 0)
        return null;

    var personFullNameRishon = util.toRishonLetters(personFullName); //are these comparisons too slow? too speed this up in the future, a separated flattened list of names can be preloaded from the server
    var filteredNodes = graphData.nodes.filter((element) => {
        if (element.type != "person" || element.fullName == null || element.name == null)
            return false;
        var fullName = element.fullName;
        var name = util.removeNikud(element.name);
        var aliases = (element.aliases || "");
        if (   (fullName.includes(personFullName) || fullName.includes(personFullNameRishon)) ||
               (fullName.length >= 3 && (personFullName.includes(fullName) || personFullNameRishon.includes(fullName))) ||
               (name.includes(personFullName) || name.includes(personFullNameRishon)) ||
               (name.length >= 3 && (personFullName.includes(name) || personFullNameRishon.includes(name))) ||
               (aliases.includes(personFullName) || aliases.includes(personFullNameRishon)) ||
               (aliases.length >= 3 && (personFullName.includes(aliases) || personFullNameRishon.includes(aliases))) )
               return true;

        var distance = util.levenshteinDistance(name, personFullName);
        //if (name == "משה")
        //    alert(distance <= 3 && (distance / name.length) <= 0.5);
        return distance <= 3 && (distance / name.length) <= 0.5;
    });

    if (filteredNodes.length == 0)
        return null;

    var startsWith = filteredNodes.filter((element) => {
        var fullName = element.fullName;
        var name = util.removeNikud(element.name);
        var aliases = (element.aliases || "");
        if (   fullName.startsWith(personFullName) || personFullName.startsWith(fullName) ||
               fullName.startsWith(personFullNameRishon) || personFullNameRishon.startsWith(fullName) ||
               name.startsWith(personFullName) || personFullName.startsWith(name) ||
               name.startsWith(personFullNameRishon) || personFullNameRishon.startsWith(name) ||
               aliases.startsWith(personFullName) || (aliases.length >= 3 && personFullName.startsWith(aliases)) ||
               aliases.startsWith(personFullNameRishon) || (aliases.length >= 3 && personFullNameRishon.startsWith(aliases)) )
               return true;
    });

    //top preference = exact match
    var initialNode = startsWith.find((element) => {return element.fullName == personFullName || util.removeNikud(element.name) == personFullName || element.aliases == personFullName;});
    if (initialNode != null)
        return initialNode;

    var sortedNodes = null;
    //otherwise fallback to levenshtein dist
    //alert("filteredNodes:" + filteredNodes.length)
    if (filteredNodes.length <= 30) {
        sortedNodes = filteredNodes.sort((a, b) => {
            var aname = util.removeNikud(a.name);
            var bname = util.removeNikud(b.name);
            var adist = util.levenshteinDistance(aname, personFullName) / aname.length;
            var bdist = util.levenshteinDistance(bname, personFullName) / bname.length;

            if (adist < bdist)
                return -1;
            else if (bdist > adist)
                return 1;

            return 0;
        }); //sort by lowest distance
    }

    //next preference = close distance
    if (sortedNodes != null && util.levenshteinDistance(util.removeNikud(sortedNodes[0].name), personFullName) <= 1)
        return sortedNodes[0];

    //next preference = starts with
    if (startsWith.length > 0 && startsWith.length < 10)
        return startsWith[0];

    //next preference = any near distance
    if (sortedNodes != null)
        return sortedNodes[0];

    return null;
  }

  setFocusedNode(node) {
      this.setState({focusedNode: node, comparisonNode: this.state.findRelationIsOpen ? this.state.comparisonNode : null, yichusPath: [], pathNodeIds : [],
                     ancestorNodeIds : [], descendantNodeIds : [], ancestorNodeDepths : [], descendantNodeDepths : []}, () => {
          if (this.state.showAncestors)
              this.fetchLineage("Ancestors");

          if (this.state.showDescendants)
              this.fetchLineage("Descendants");

          if (this.state.findRelationIsOpen && this.state.comparisonNode)
              this.findYichus();
      });
  }

  setComparisonNode(node) {
      this.setState({comparisonNode: node}, () => {
          this.findYichus();
      })
  }

  setRightClickedNode(node) {
    this.setState({rightClickedNode: node});
  }

  cancelTreeRightClick(){
    contextMenu.hideAll();
  }

  getNameDropdownData(graphData) {
      var nameDropdownData = [];
      var i;

      for (i=0; i < graphData.nodes.length; i++) {
          if (graphData.nodes[i].type == "person")
              nameDropdownData.push(graphData.nodes[i]);
      }

      nameDropdownData = nameDropdownData.sort((a,b) => {
      //alphabetize nodes by name (without nekudot)
      if (util.removeNikud(a.name) > util.removeNikud(b.name)) {
          return 1;
      }
      if (util.removeNikud(b.name) > util.removeNikud(a.name)) {
          return -1;
      }
      return 0;
      })
      return nameDropdownData;
  }

  /*
   getNewBaseParameters() {
     return new BaseParameters();
   }

  async getYuchsinData() {
  //alert('in getYuchsinData');
      var baseParams = this.getNewBaseParameters();
      var graphData = {"nodes": [], "links": []};
      const response = await fetch(properties.env.webServiceURL + '/BaseHaSefer/getObjectRelationships', {method: 'post', body: JSON.stringify(baseParams)});
      const serverData = await response.json();
      var set = new Set();
      for(row in serverData) {
         set.add(row.obj1)
         set.add(row.obj2)
      }
      for(var name in set) {
         graphData.nodes.push({"id": name, "name": name})
      }
      for(var row in serverData) {
          graphData.links.push({"source": row.obj2, "target": row.obj1})
      }

      this.setState({
          yuchsinData: graphData
      })
      //create new JSON object with nodes and links
      //iterate over obj1 and obj2 and add to nodes
      //for each relationship add link - obj1 = source, obj2 = target
  }*/

  findHighestZIndex(elem) {
    var elems = document.getElementsByTagName("*");
    var highest = 0;
    for (var i = 0; i < elems.length; i++) {
      var zindex = document.defaultView.getComputedStyle(elems[i], null).getPropertyValue("z-index");
      if ((zindex > highest) && (zindex != 'auto') && (zindex != 9998) && (zindex != 100000090)) {
        highest = zindex;
      }
    }
    return parseFloat(highest);
  }

  showOnTop() {
    this.setState({
      zIndex: this.findHighestZIndex() + 1
    })
  }

  handleClick(e) {
    this.showOnTop();
  }

  handleFullscreen() {
    this.props.handleFullscreen();
  }

  handleSplitScreen() {
    this.props.handleSplitScreen();
  }

  handleCopyLink() {
    var params = [];
    if (this.state.focusedNode)
        params.push("name=" + this.state.focusedNode.fullName);
    if (this.state.comparisonNode)
        params.push("name2=" + this.state.comparisonNode.fullName);
    if (this.state.isPathPlaying)
        params.push("animate=T");
    if (!properties.isDarkMode)
        params.push("darkmode=F");

    this.props.handleCopyLink("3Dtree", params, this.props.isFullScreen(this.props.x, this.props.y, this.props.heightNum,this.props.widthNum));
  }

  async handleClose() {
    this.props.toggleOpen(false);
    this.clearAll();
  }

  clearAll() {
    this.setState({

    })
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.isOpen && !prevProps.isOpen) {
      this.showOnTop();
      this.getYuchsinData("opener");  //logic in getYuchsinData() will enforce that can only fetch general data once
    }
    if(this.state.rowDataLength !== prevState.rowDataLength){
      this.state.textSelectorApi.gridOptionsWrapper.gridOptions.api.ensureIndexVisible(this.state.rowDataLength,'bottom')
    }
  }

   handlePeople(data){
       var peopleList = [];
       data.forEach((item)=>{
            peopleList.push({label: item.name, value:item.name})
       });
       peopleList.sort((a,b)=>{
            var nameA = a.label;
            var nameB = b.label;
            if(nameA>nameB){
                return 1;
                }
            if (nameB>nameA){
                return -1;
                }
            else {
                return 0;
                }
            }
       )
       this.setState({peopleData: peopleList})
   }

  async refresh(){
    var textSelectorData = this.state.textSelectorData;
    //alert("refresh called. source count: " + textSelectorData.length);
    this.getYuchsinData("refresh");
  }

    async setHelpTopic(topic) {
        localStorage.setItem("helpDialogStartupTopic", topic);
    }

  async searchPersonInTanach(){
    //console.log("searching")
    //console.log(this.state.rightClickedNode)

    this.handleSplitScreen();

    var timelineParams = new TimelineParameters();

    if (this.state.focusedNode == null) {
        alert("You must select a person.");
        return;
    }

    timelineParams.objectId = this.state.focusedNode.id;

    //the following forces a dummy term so that buildMatchColorMap() will work for a single generic term since searching a single person
    var termParameters = new TermParameters();
    termParameters.term = "*";
    timelineParams.bituiParameters = [termParameters];
    timelineParams.matchColorMap = util.buildMatchColorMap(timelineParams.bituiParameters);

    var filterIds = encodeFilterIds(this.props.extFilterData);

    filterIds = parseInt(filterIds, 2).toString(16).toUpperCase();
    filterIds = util.right("00000000000"+filterIds,11);

    timelineParams.filterIds = filterIds;
    timelineParams.sortDirection = this.props.sortDirection;//sortDirection from right bar
    timelineParams.sortOrder = this.props.sortOrder;
    timelineParams.sortedColumn = this.props.sortedColumn;

    var e, i, j, k;
    for (i = 0; i < this.state.textSelectorData.length-1; i++) { //last position in textSelectorData is never populated
        e = this.state.textSelectorData[i];
        if (e.type)
            timelineParams.namedLocations.push(new NamedLocation(e.val4, e.val5)); //kriaId, aliyaId
        else
            timelineParams.pasukRangeLocations.push(new PerekPasukRange(e.val1, e.val2, e.val3, e.val4, e.val5, e.val6)); //int
    }

    this.setHelpTopic("searchResults");

    //event.preventDefault();
    //this.props.setSearchIsLoading(true);

    this.props.extOpenSearchResults();

    this.props.extInitializeSearchState();

    var url = properties.env.webServiceURL + '/BaseHaSefer/getPesukimWithObject';

    const response = await fetch(url, {method: 'post', body: JSON.stringify(timelineParams)});
    const responseBody = await response.json();

    const searchData = {
        results: responseBody,
        searchParams: timelineParams
    }

    this.props.extOpenSearchResults(searchData, this.state.focusedNode.fullName); //do this to update search results grid governed by Home.js

    this.props.setSearchIsLoading(false);

  }

  toggleAncestors() {
      const isOn = !this.state.showAncestors;
      this.setState({showAncestors: isOn});
      if (this.state.ancestorNodeIds.length == 0)
          this.fetchLineage("Ancestors");
  }

  toggleDescendants() {
      const isOn = !this.state.showDescendants;
      this.setState({showDescendants: !this.state.showDescendants});
      if (this.state.descendantNodeIds.length == 0)
          this.fetchLineage("Descendants");
  }

  async fetchLineage(direction) {
        var nodeId = this.state.focusedNode.id;

        var response = await fetch(properties.env.webServiceURL + '/BaseHaSefer/find' + direction + '?nodeId=' + nodeId + '&source=bhsWebApp');
        var body = await response.json();

        if (direction == "Ancestors")
            //this.setState({ancestorNodeIds: body && body.length > 0 ? body : []});
            this.setState({ancestorNodeIds: body && body.length > 0 ? body.map(x => x.id) : [], ancestorNodeDepths: body && body.length > 0 ? body.map(x => x.depth) : []});
        else
            //this.setState({descendantNodeIds: body && body.length > 0 ? body : []});
            this.setState({descendantNodeIds: body && body.length > 0 ? body.map(x => x.id) : [], descendantNodeDepths: body && body.length > 0 ? body.map(x => x.depth) : []});
  }

  handleOpenFindRelation(e){
    this.setState({
      findRelationIsOpen: true,
      findRelationAnchorEl: e.currentTarget
    })
  }

  handleCloseFindRelation(){
    this.setState({
      findRelationIsOpen: false,
      findRelationAnchorEl: null,
      comparisonNode: null, yichusPath: [], pathNodeIds : [], isPathPlaying: false
    })
  }

    setFindRelationSize(widthNum, heightNum, x, y){
        var findRelationPosition = {
            x: x,
            y: y,
            widthNum: widthNum,
            heightNum: heightNum
        }
        this.setState({findRelationPosition})
    }

    setFindRelationPosition(x, y){
        var newFindRelationPosition = {
            x: x,
            y: y,
            heightNum: this.state.findRelationPosition.heightNum,
            widthNum: this.state.findRelationPosition.widthNum,
        };
        this.setState({findRelationPosition: newFindRelationPosition})
    }

  async findYichus(callback) {
        var nodeId1 = this.state.focusedNode.id;
        var nodeId2 = this.state.comparisonNode.id;

        const noRelation = this.props.translate("noRelation");

        var response = await fetch(properties.env.webServiceURL + '/BaseHaSefer/findYichus?nodeId1=' + nodeId1 + '&nodeId2=' + nodeId2 + '&source=bhsWebApp');
        var body = await response.json();
        var summary = body.summary;
        var path = body.path;
        var descriptionPath = body.descriptionPath;
        var i;
        if (!descriptionPath || descriptionPath.length == 0)
            descriptionPath = [{name: noRelation, relationshipType: "", categoryType: ""}];
        else
            descriptionPath[descriptionPath.length-1].relationshipType = ""; //remove any content for relation info of last element since won't get displayed

//const isInPath = (id) => path.find(e => e.id == id);
//const pathNodes = this.state.yuchsinData.nodes.filter(node => isInPath(node.id));
//if (pathNodes && pathNodes.length > 0)
//    alert(pathNodes[0].id + ":" + pathNodes[0].name);
//  this.setState({
//    todoList: {
//      ...this.state.todoList,
//      day,
//      items: []
//    }
//  })
        this.setState({yichusPath: descriptionPath, pathNodeIds: path != null ? path.map(x => x.id) : []}, () => {
                                                                                                                   if(callback){
                                                                                                                     callback();
                                                                                                                   }
                                                                                                                 });

//      this.setState({comparisonNode: node}, () => {
//          this.findYichus();
//      })

  }

  setFindRelationDraggable(flag) {
      this.setState({findRelationDraggable : flag});
      //if (!flag) //reenable after being temporarily disabled
      //    setTimeout('setFindRelationDraggable(true)', 1000);

  }

  handlePathTextKeyDown(e) {} // superseded by handleGlobalKeyDown; kept to avoid stale binding errors

  // Kalman Claudsky: intercept Ctrl+A when the user's selection or focus is inside the
  // relation-path text box, so "select all" scopes to that box rather than the whole page.
  // Two conditions cover both use-cases: (1) user dragged to create a partial selection,
  // (2) user simply clicked inside the box (collapsed selection, element may not be focused).
  handleGlobalKeyDown(e) {
      if (!(e.ctrlKey && e.key.toLowerCase() === 'a')) return;
      const el = this.pathTextRef.current;
      if (!el) return;
      const sel = window.getSelection();
      const selectionInside = sel && sel.rangeCount > 0 &&
          el.contains(sel.getRangeAt(0).commonAncestorContainer);
      const focusInside = el === document.activeElement || el.contains(document.activeElement);
      if (selectionInside || focusInside) {
          e.preventDefault();
          e.stopPropagation();
          const range = document.createRange();
          range.selectNodeContents(el);
          sel.removeAllRanges();
          sel.addRange(range);
      }
  }

  toggleGenerationsPlayPause() {
      if (this.state.focusedNode && (this.state.showAncestors || this.state.showDescendants)) //only enable this if a name was already selected
          this.setState({isGenerationsPlaying: !this.state.isGenerationsPlaying});
  }

  toggleGenerationsAll() {
      if (this.state.focusedNode && !this.state.isGenerationsAll) //only enable this if a name was already selected
          this.setState({isGenerationsAll: true, isGenerationsOne: false});
  }

  toggleGenerationsOne() {
      if (this.state.focusedNode && !this.state.isGenerationsOne) //only enable this if a name was already selected
          this.setState({isGenerationsOne: true, isGenerationsAll: false});
  }

  toggleRepeatGenerationsFromStart() {
      if (this.state.focusedNode) //only enable this if a name was already selected
          this.setState({isRepeatGenerationsFromStart: !this.state.isRepeatGenerationsFromStart, isRepeatGenerationsFromEnd: false});
  }

  toggleRepeatGenerationsFromEnd() {
      if (this.state.focusedNode) //only enable this if a name was already selected
          this.setState({isRepeatGenerationsFromEnd: !this.state.isRepeatGenerationsFromEnd, isRepeatGenerationsFromStart: false});
  }

  togglePathPlayPause() {
      if (this.state.comparisonNode) //only enable this if a name was already selected
          this.setState({isPathPlaying: !this.state.isPathPlaying});
  }

  toggleRepeatPathFromStart() {
      if (this.state.comparisonNode) //only enable this if a name was already selected
          this.setState({isRepeatPathFromStart: !this.state.isRepeatPathFromStart, isRepeatPathFromEnd: false});
  }

  toggleRepeatPathFromEnd() {
      if (this.state.comparisonNode) //only enable this if a name was already selected
          this.setState({isRepeatPathFromEnd: !this.state.isRepeatPathFromEnd, isRepeatPathFromStart: false});
  }

  playRepeatFromEnd() {
      this.togglePathPlayPause();
      this.toggleRepeatPathFromEnd();
  }


  render() {
    const { classes } = this.props;
    const fakeThis = this;
    const { isLoading } = this.state;
    const isHebrew = this.props.activeLanguage && this.props.activeLanguage.code === 'he';
    const close = this.props.translate('close');
    const copyLink = this.props.translate('copyLink');
    const loadingText = this.props.translate("loading");
    const fullScreen = this.props.translate("fullScreen");
    const splitScreen = this.props.translate("splitScreen");
    const select = this.props.translate("select");
    const clearAll = this.props.translate("clearAll");
    const yuchsinTree = this.props.translate('yuchsinTree');
    const refresh = this.props.translate('refresh');
    const searchInTanach = this.props.translate("searchInTanach");
    const findRelation = this.props.translate("findRelation");
    const relationPath = this.props.translate("relationPath");
    const findByNodeClick = this.props.translate('findByNodeClick');
    const findRelationCaption = this.props.translate('findRelationCaption');
    const turnAncestorsOn = this.props.translate('turnAncestorsOn');
    const turnAncestorsOff = this.props.translate('turnAncestorsOff');
    const turnDescendantsOn = this.props.translate('turnDescendantsOn');
    const turnDescendantsOff = this.props.translate('turnDescendantsOff');
    const maxGenerations = this.props.translate('maxGenerations');
    const smallAdjustments = this.props.translate('smallAdjustments');
    const recommendFullscreen = this.props.translate('recommendFullscreen');
    const settings = this.props.translate('settings');
    const selectGenerationsToPlayTip = this.props.translate('selectGenerationsToPlayTip');
    const selectPathToPlayTip = this.props.translate('selectPathToPlayTip');
    const playTip = this.props.translate('playTip');
    const pauseTip = this.props.translate('pauseTip');
    const repeatFromStartTip = this.props.translate('repeatFromStartTip');
    const repeatFromEndTip = this.props.translate('repeatFromEndTip');
    const repetitionOffTip = this.props.translate('repetitionOffTip');
    const allGenerationsTip = this.props.translate('allGenerationsTip');
    const oneGenerationTip = this.props.translate('oneGenerationTip');

    const isShowAncestors = this.state.showAncestors;
    const isShowDescendants = this.state.showDescendants;
    const isGenerationsPlaying = this.state.isGenerationsPlaying;
    const isGenerationsAll = this.state.isGenerationsAll;
    const isGenerationsOne = this.state.isGenerationsOne;
    const isRepeatGenerationsFromStart = this.state.isRepeatGenerationsFromStart;
    const isRepeatGenerationsFromEnd = this.state.isRepeatGenerationsFromEnd;
    const isPathPlaying = this.state.isPathPlaying;
    const isRepeatPathFromStart = this.state.isRepeatPathFromStart;
    const isRepeatPathFromEnd = this.state.isRepeatPathFromEnd;

    const popupHeightNum = this.props.heightNum
    var dialogContentHeight = popupHeightNum - 50;

    var directionStyling = { direction: 'ltr', textAlign: 'left', justifyContent: 'left' }
    if (this.props.activeLanguage && this.props.activeLanguage.code === "he") {
      directionStyling = { direction: 'rtl', textAlign: 'right', justifyContent: 'right' }
    }

    var searchSettingsLabelCellStyle = {
      textAlign: directionStyling.textAlign
    }
    var searchSettingsInputCellStyle = {
      textAlign: isHebrew ? "left" : "right"
    }


    return (
      <>
      <Rnd
        helpTopic="YuchsinTreeViewer"
        size={{ width: `${this.props.widthNum}px`, height: `${this.props.heightNum}px` }}
        position={{ x: this.props.x, y: this.props.y }}
        onDragStop={(e, d) => {
          this.props.setPosition(d.x, d.y)
          // this.setState({ x: d.x, y: d.y })
        }}
        onClick={(e) => { this.handleClick() }}
        onResize={(e, direction, ref, delta, position) => {
          this.props.setSize(
            parseInt(ref.style.width.slice(0, -1)),
            parseInt(ref.style.height.slice(0, -1)),
            position.x,
            position.y
          )
        }}
        style={{
          backgroundColor: 'rgb(255, 238, 223)',
          visibility: this.props.isOpen ? 'visible' : 'hidden',
          boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
          borderRadius: '5px',
          zIndex: this.state.zIndex
        }}
        // Kalman Claudsky: added .yuchsin-name-filter-input and .yuchsin-name-dropdown-list after
        // replacing react-dropdown-tree-select with a custom combobox. Without these entries the
        // Rnd drag handler captures mousedown on the input and prevents focus/typing entirely.
        cancel='.react-dropdown-tree-select, .yuchsin-name-filter-input, .yuchsin-name-dropdown-list, .yuchsin-tree-source-selector-popover *, .LCS-open-settings-button, .MuiDialog-container-16, .object-cloud-selector, .tanach-viewer-content, .tanach-viewer-text-display-controls, .placement-selector-2D-selector, .placement-selector-2D-popover, .tanach-viewer-resize-buttons'
        minWidth={740}
        minHeight={153}
        bounds='#root'
        className="tanach-viewer-rnd"
      >
        <div className="tanach-viewer-resize-buttons"
          style={{
            position: 'absolute',
            right: isHebrew ? 'unset' : 0,
            left: isHebrew ? 0 : 'unset',
            direction: isHebrew ? 'ltr' : 'rtl',
            top: 0,
            borderBottomLeftRadius: isHebrew ? 0 : '3px',
            borderBottomRightRadius: isHebrew ? '3px' : 0,
          }}
        >
          <Button className="tanach-viewer-resize-button" onClick={() => { this.handleClose() }} title={close} helpTopic="layout">
            <CloseIcon />
          </Button>
          <Button className="tanach-viewer-resize-button" onClick={() => { this.handleCopyLink() }} title={copyLink}>
            <LinkIcon />
          </Button>
          <Button className="tanach-viewer-resize-button" onClick={() => { this.handleSplitScreen() }} title={splitScreen}>
            <HorizontalSplitIcon />
          </Button>
          <Button className="tanach-viewer-resize-button" onClick={() => { this.handleFullscreen() }} title={fullScreen}>
            <FullscreenIcon />
          </Button>
        </div>
        <DialogTitle style={{
          direction: directionStyling.direction, textAlign: "center",
          maxWidth: 'calc(100% - 30px)',
          margin: 'auto',
          padding: '10px 0',
        }}>
          <span className="medCaption" align="center">{yuchsinTree}</span>&nbsp;&nbsp;
          <NameDropdown id="zz1" className="yuchsin-name-dropdown"
            disabled={this.props.isGenerationsPlaying || this.state.isPathPlaying}
            nodeSelected={this.state.focusedNode}
            setFocusedNode={(nameItem) => {this.setFocusedNode(this.state.yuchsinData.nodes[nameItem.index])}}
            dropdownData={this.state.nameDropdownData}
          />
          <IconButton className="yuchsin-tree-search" aria-label="Search" title={searchInTanach} onClick={this.searchPersonInTanach} disabled={!this.state.focusedNode}><SearchIcon /></IconButton>
          <ToggleIconButton isPressed={isShowAncestors} onImage={ancestorsOn} offImage={ancestorsOff} onTip={turnAncestorsOff} offTip={turnAncestorsOn}
                            height={28} width={28} toggleAction={this.toggleAncestors} disabled={!this.state.focusedNode} />
          &nbsp;
          <Button variant="default" style={{ verticalAlign: '-8px'}} className="LCS-open-settings-button" title={settings} onClick={(e) => {this.handleOpenSettings(e)}}>
            <SettingsIcon/>
          </Button>
          &nbsp;
          <ToggleIconButton isPressed={isShowDescendants} onImage={descendantsOn} offImage={descendantsOff} onTip={turnDescendantsOff} offTip={turnDescendantsOn}
                            height={28} width={28} toggleAction={this.toggleDescendants} disabled={!this.state.focusedNode} />
          <IconButton className="yuchsin-tree-search" aria-label="Search" title={findRelation} onClick={(e) => {this.handleOpenFindRelation(e)}} disabled={!this.state.focusedNode}>
              <img src={nodeConnect} height="15" width="39" align="center" />
          </IconButton>
          &nbsp;&nbsp;
          <YuchsinSectionSelector
            textSelectorData={this.state.textSelectorData}
            textSelectorGridReady={this.textSelectorGridReady}
            addTextSelectorRow={this.addTextSelectorRow}
            extAddTextSelectorRow={this.extAddTextSelectorRow}
            deleteTextSelectorRow={this.deleteTextSelectorRow}
            extDeleteTextSelectorRow={this.extDeleteTextSelectorRow}
            extModifyTextSelectorRow={this.extModifyTextSelectorRow}
            modifyTextSelectorRow={this.modifyTextSelectorRow}
            getRenderVals={this.getTextSelectorRenderVals}
          />&nbsp;
          <Button
            variant="contained"
            color="primary"
            className="parsha-viewer-control-button"
            type="submit"
            style={{margin: '0 5px'}}
            onClick={() => {this.refresh()}}
          >
            {refresh}
          </Button>
        </DialogTitle>
        <LoadingOverlay
          active={this.state.isLoading}
          spinner
          text={loadingText}
        >
          <DialogContent className="tanach-viewer-content" style={{
            direction: 'rtl',
            maxHeight: `${dialogContentHeight}px`,
            minHeight: `${dialogContentHeight}px`,
            padding: '0 0 0px',
            margin: '0 24px',
            overflow: 'hidden'
          }}>
            <DialogContentText style={{ direction: 'rtl', textAlign: 'right' }}>
              <div id="tanach-viewer-text-display">
                  <YuchsinTree
                    extGetData={this.getYuchsinData}
                    extFilterData={this.props.extFilterData}
                    data={this.state.yuchsinData}
                    yOffset={6300}
                    focusedNode={this.state.focusedNode}
                    isViewerOpenedYet={this.state.isViewerOpenedYet}
                    comparisonNode={this.state.comparisonNode}
                    findRelationIsOpen={this.state.findRelationIsOpen}
                    setFocusedNode={(node) => {this.setFocusedNode(node)}}
                    setComparisonNode={(node) => {this.setComparisonNode(node)}}
                    setRightClickedNode={(node) => this.setRightClickedNode(node)}
                    showAncestors={this.state.showAncestors}
                    showDescendants={this.state.showDescendants}
                    pathNodeIds={this.state.pathNodeIds}
                    ancestorNodeIds={this.state.ancestorNodeIds}
                    descendantNodeIds={this.state.descendantNodeIds}
                    ancestorNodeDepths={this.state.ancestorNodeDepths}
                    descendantNodeDepths={this.state.descendantNodeDepths}
                    maxGenerations={this.state.maxGenerations}
                    isGenerationsPlaying={this.state.isGenerationsPlaying}
                    isGenerationsAll={this.state.isGenerationsAll}
                    isGenerationsOne={this.state.isGenerationsOne}
                    isRepeatGenerationsFromStart={this.state.isRepeatGenerationsFromStart}
                    isRepeatGenerationsFromEnd={this.state.isRepeatGenerationsFromEnd}
                    isPathPlaying={this.state.isPathPlaying}
                    isRepeatPathFromStart={this.state.isRepeatPathFromStart}
                    isRepeatPathFromEnd={this.state.isRepeatPathFromEnd}
                    toggleGenerationsPlayPause={this.toggleGenerationsPlayPause}
                    togglePathPlayPause={this.togglePathPlayPause}
                    height={dialogContentHeight - 20}
                    width={this.props.widthNum - 50}
                    peopleData={this.handlePeople}
                    cancelRightClick={this.cancelTreeRightClick}
                    extSetAboutTabIndex={this.props.extSetAboutTabIndex}
                    personFullName={this.props.personFullName}
                    zoomDistance={this.props.zoomDistance}
                    initialDarkMode={this.props.initialDarkMode}
                  />

              </div>
            </DialogContentText>
          </DialogContent>
        </LoadingOverlay>
      </Rnd>

          <Popover
            open={this.state.settingsIsOpen}
            anchorEl={this.state.settingsAnchorEl}
            onClose={this.handleCloseSettings}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: `${isHebrew ? "right" : "left"}`,
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: `${isHebrew ? "right" : "left"}`,
            }}
            elevation={1}
            className="generations-selector-2D-popover"
            style={{
              direction: `${isHebrew ? 'rtl' : 'ltr'}`,
            }}
            classes={{ paper: "LCS-search-settings-popover-paper" }}
          >

            <table className="LCS-search-setting-parent-table" width="100%">
              <tr>
                <td style={searchSettingsLabelCellStyle}>
                  <Typography variant='body1' style={{display:'inline', fontWeight: 'bold'}}>{maxGenerations}:</Typography>
                </td>
                <td style={searchSettingsInputCellStyle}>
                  <Typography variant='body1' className='LCS-distance-label'>{1}</Typography>
                  <Slider reverse={isHebrew} className='generations-slider' min={1} max={60} step={1} included={false} tipFormatter={value => this.getDisplayValue(value)} value={this.state.maxGenerations} onChange={this.setMaxGenerations}
                    style={{
                      marginLeft: isHebrew ? '-4px' : '16px',
                      marginRight: isHebrew ? '12px' : '-10px',
                    }}
                  />
                  <Typography variant='body1' className='LCS-distance-label'>{this.state.maxGenerationsDisplay}</Typography>
                </td>
              </tr>
              <tr style={{height: '50px', verticalAlign: 'top'}}>
                  <td colspan={2} style={{fontSize: '11px', textAlign: 'center'}}><i>{smallAdjustments}</i></td>
              </tr>
              <tr>
                  <td colspan={2}>
                      <div className="generations-buttons">
                                <ToggleIconButton isPressed={isGenerationsAll} onImage={allGenerationsOn} offImage={allGenerationsOff} onTip={allGenerationsTip} offTip={allGenerationsTip}
                                                  height={32} width={32} toggleAction={this.toggleGenerationsAll} disabled={false} />
                                &nbsp;
                                <ToggleIconButton isPressed={isGenerationsOne} onImage={oneGenerationOn} offImage={oneGenerationOff} onTip={oneGenerationTip} offTip={oneGenerationTip}
                                                  height={32} width={32} toggleAction={this.toggleGenerationsOne} disabled={false} />
                                &nbsp;&nbsp;

                                <ToggleIconButton isPressed={isRepeatGenerationsFromStart} onImage={repeatFromStartOn} offImage={repeatFromStartOff} onTip={repetitionOffTip} offTip={repeatFromStartTip}
                                                  height={32} width={32} toggleAction={this.toggleRepeatGenerationsFromStart} disabled={false} />
                                <ToggleIconButton isPressed={isRepeatGenerationsFromEnd} onImage={repeatFromEndOn} offImage={repeatFromEndOff} onTip={repetitionOffTip} offTip={repeatFromEndTip}
                                                  height={32} width={32} toggleAction={this.toggleRepeatGenerationsFromEnd} disabled={false} />
                                &nbsp;&nbsp;
                                <ToggleIconButton isPressed={isGenerationsPlaying} onImage={pause} offImage={play} onTip={pauseTip} offTip={this.state.focusedNode && (isShowAncestors || isShowDescendants) ? playTip : selectGenerationsToPlayTip}
                                                  height={32} width={32} toggleAction={this.toggleGenerationsPlayPause} disabled={false} />
                      </div>
                  </td>
              </tr>
              <tr>
                  <td colspan={2} style={{fontSize: '11px', textAlign: 'center'}}><i>{recommendFullscreen}</i></td>
              </tr>
            </table>
          </Popover>

          <Rnd
          //helpTopic="objectCloudViewer"
          //size={{ width: `${this.props.widthNum}px`,  height: `${this.props.heightNum}px` }}
          open={this.state.findRelationIsOpen}
          position={{ x: this.props.x + this.state.findRelationPosition.x, y: this.props.y + this.state.findRelationPosition.y }}
          onDragStop={(e, d) => {
            if (this.state.findRelationDraggable)
                this.setFindRelationPosition(d.x - this.props.x, d.y - this.props.y);
            this.setFindRelationDraggable(true); //this fixes situation where the child div's scrollbar is dragged and don't want to reposition
            //this.setState({ x: d.x, y: d.y })
          }}
          //onClick={(e) => {this.handleClick()}}
//          onResize={(e, direction, ref, delta, position) => {
//          //return false;
//            this.props.setSize(
//              parseInt(ref.style.width.slice(0, -1)),
//              parseInt(ref.style.height.slice(0, -1)),
//              position.x,
//              position.y
//            )
//          }}
          style = {{
            backgroundColor: 'rgb(255, 238, 223)',
            visibility: this.props.isOpen && this.state.findRelationIsOpen ? 'visible' : 'hidden',
            boxShadow: '0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)',
            borderRadius: '5px',
            direction: `${isHebrew ? 'rtl' : 'ltr'}`,
            zIndex: this.state.zIndex+1
          }}
          // Kalman Claudsky: .yuchsin-name-* entries allow typing in the second name dropdown;
          // .yuchsin-pathText-container and .yuchsin-pathText allow click-drag text selection
          // in the relation-path area without the Rnd interpreting the drag as a window move.
          cancel = '.LCS-open-settings-button, .MuiDialog-container-16, .object-cloud-selector, .tanach-viewer-content, .tanach-viewer-text-display-controls, .placement-selector-2D-selector, .placement-selector-2D-popover, .tanach-viewer-resize-buttons, .yuchsin-name-filter-input, .yuchsin-name-dropdown-list, .yuchsin-pathText-container, .yuchsin-pathText'
          minWidth={380}
          minHeight={340}
          //disableDragging={!this.state.findRelationDraggable}
          bounds='#root'
          enableResizing={false}  //there is a glitch where resizing the popup will disable use of scrollbar on the child div - so can't have that
          enableUserSelectHack={false} //without doing this, can't get focus by clicking and interacting with any contents of the <Rnd> container
          //className="tanach-viewer-rnd"
          //className="yuchsin-pathText-container"
          //className="placement-selector-2D-popover"
          className="LCS-search-settings-popover-paper"
          >
        <div className="tanach-viewer-resize-buttons"
          style={{
            position: 'absolute',
            right: isHebrew ? 'unset' : 0,
            left: isHebrew ? 0 : 'unset',
            direction: isHebrew ? 'ltr' : 'rtl',
            top: 0,
            borderBottomLeftRadius: isHebrew ? 0 : '3px',
            borderBottomRightRadius: isHebrew ? '3px' : 0,
          }}
        >
          <Button className="tanach-viewer-resize-button" onClick={() => { this.handleCloseFindRelation() }} title={close} helpTopic="layout">
            <CloseIcon fontSize="small" />
          </Button>
        </div>
              <div className="yuchsin-person2-selector">
                  <span style={{color: 'blue', fontWeight: 'bold', marginTop: '5px'}}>{findRelationCaption}</span>
                  <span className="yuchsin-focusedNode">
                      <NameDropdown id="zz2" className="yuchsin-name-dropdown"
                        disabled={this.props.isGenerationsPlaying || this.state.isPathPlaying}
                        nodeSelected={this.state.comparisonNode}
                        setFocusedNode={(nameItem) => {this.setComparisonNode(this.state.yuchsinData.nodes[nameItem.index])}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           }
                        dropdownData={this.state.nameDropdownData}
                      />
                  </span>
              </div>
              <div ref={this.pathTextRef} className="yuchsin-pathText-container" onScroll={() => this.setFindRelationDraggable(false)}>
                  <Paper tabIndex={0} className="yuchsin-pathText" style={{whiteSpace: 'pre-line', textAlign: directionStyling.textAlign, zIndex: this.state.zIndex+1}}>
                      <YichusPath path={this.state.yichusPath} translate={this.props.translate} />
                  </Paper>
              </div>
              <div className="yuchsin-findPath-bottom">
                  <div className="yuchsin-findPath-bottom-caption">
                      {relationPath}
                  </div>
                  <div className="yuchsin-findPath-bottom-button" onmouseover={() => this.setFindRelationDraggable(false)}>
                            <ToggleIconButton isPressed={isRepeatPathFromStart} onImage={repeatFromStartOn} offImage={repeatFromStartOff} onTip={repetitionOffTip} offTip={repeatFromStartTip}
                                              height={32} width={32} toggleAction={this.toggleRepeatPathFromStart} disabled={false} />
                            <ToggleIconButton isPressed={isRepeatPathFromEnd} onImage={repeatFromEndOn} offImage={repeatFromEndOff} onTip={repetitionOffTip} offTip={repeatFromEndTip}
                                              height={32} width={32} toggleAction={this.toggleRepeatPathFromEnd} disabled={false} />
                            <ToggleIconButton isPressed={isPathPlaying} onImage={pause} offImage={play} onTip={pauseTip} offTip={this.state.comparisonNode ? playTip : selectPathToPlayTip}
                                              height={32} width={32} toggleAction={this.togglePathPlayPause} disabled={false} />
                  </div>
              </div>
          </Rnd>
          </>
    );
  }
}

YuchsinTreeViewer.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withLocalize(YuchsinTreeViewer));

/*
this onClick() was causing conflict in the underlying onChange method from the react-dropdown since it's essentially proxied from an onClick()
                  <span className="yuchsin-focusedNode" onClick={() => this.setFindRelationDraggable(false)}>


          <span className="yuchsin-focusedNode">{this.state.focusedNode ? this.state.focusedNode.fullName : ""}</span>

                  <span className="yuchsin-focusedNode">
                      {this.state.comparisonNode ? this.state.comparisonNode.fullName : ""}
                  </span>

          style = {{zIndex: this.state.zIndex+1}}
                              <Button
                                variant="contained"
                                color="primary"
                                className="parsha-viewer-control-button"
                                type="submit"
                                style={{width: '190px'}}
                                onClick={() => {this.findYichus()}}
                              >
                                {findByNodeClick}
                              </Button>

mje Aug 31 - the search here works all the way to the server but can't properly display results window on the client - probably have to fire regular search like TanachViewer does from context menu and stick objectId into regular search?????
          <IconButton className="yuchsin-tree-search" aria-label="Search" title={searchInTanach} onClick={this.searchPersonInTanach}><SearchIcon /></IconButton>

removed this wrapper from YuchsinTree component
                <MenuProvider className="context-menu" id='yuchsin-tree-context-menu'
                  style={{
                    maxHeight: dialogContentHeight - 20,
                    width: '1520px',
                    maxWidth: 'calc(100vw - 400px)',
                    minWidth: '968px',
                  }}
                >

                </MenuProvider>

                <ContextMenu menuId='yuchsin-tree-context-menu' menuType='yuchsin-tree' className='special-context-menu'
                  nodeToSearch={this.state.rightClickedNode}
                  searchPersonInTanach={this.searchPersonInTanach}
                  textToCopy={fakeThis.state.textToCopy}
                  extCopySelectedToSearchbar={fakeThis.props.extCopySelectedToSearchbar}
                  extSearchWithSelected={fakeThis.props.extSearchWithSelected}
                  extToggleUseKinuim={fakeThis.toggleUseKinuim}
                  useKinuim={fakeThis.state.useKinuim}
                  extToggleIncludeMekorot={fakeThis.toggleIncludeMekorot}
                  includeMekorot={fakeThis.state.includeMekorot}
                  extToggleSearchAsQuote={fakeThis.toggleSearchAsQuote}
                  searchAsQuote={fakeThis.state.searchAsQuote}
                  extOpenTaamParser={fakeThis.openTaamParser}
                  currentFreq={this.state.currentFreq}
                  makor={this.state.contextMenuMakor}
                  text={this.state.contextMenuText}
                  isAPasuk={this.state.contextMenuIsAPasuk}
                  toggleTanachViewer={((boolean, pasukId, resultsApi) => {fakeThis.props.toggleTanachViewer(boolean, pasukId, resultsApi)})}
                />


*/